import {useEffect, useRef} from "react";
import {getMainWidth} from '../../utils'
import Breadcrumb from '../../components/Breadcrumb'
import './PageHeader.css'
import {Link, useNavigate, useLocation, useSearch} from "@tanstack/react-router";
import {toast} from "react-toastify";
import { signUp, validateAccount } from '../../lib/api';
import nacl from "tweetnacl";
import bcrypt from "bcryptjs";
import {from} from "../../utils/browser-buffer";
import { useAuth } from '../../lib/auth';
import { sessionStorageSet, sessionStorageGet } from '../../lib/window-shim';
import { useI18n } from '../../i18n/context';

const ValidateContainer = ({ authInfo: authInfoProp }: { authInfo?: string }) => {
    const { t } = useI18n();
    const navigate = useNavigate();
    const location = useLocation();
    const search = useSearch({ from: '/validate' });
    const isReset = search.reset === true || search.reset === 'true';
    const authInfo = authInfoProp;
    const { login } = useAuth();

    const emailRef = useRef<HTMLInputElement>(null);
    const passwordRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (!isReset) {
            let host = window.location.host.split(":")[0];
            let re = new RegExp("^((25[0-5]|(2[0-4]|1\\d|[1-9]|)\\d)(\\.(?!$)|$)){4}$");
            if (re.test(host) || host === "localhost") {
                host = host + ":54002";
            }
            console.log("PN: ", location)
            if (!authInfo) {
                toast.error(t('containers.validate.errors.invalidLink'), { autoClose: false });
                navigate({ to: '/signin' });
                return;
            }
            validateAccount(authInfo as string)
                    .then((data) => {
                        if (data?.error) {
                            toast.error(data?.message, { autoClose: false });
                            navigate({ to: "/signin" });
                        } else {
                            toast(data?.message, { autoClose: 20000 });
                            sessionStorageSet('authKey', data.account.rHash);
                            delete(data.account.authtoken)
                            const token = JSON.stringify({ auth: true, account: data.account });
                            sessionStorageSet('token', token);
                            login(JSON.parse(token));
                            if (data?.auth) {
                                navigate({ to: "/profile" });
                            }
                        }
                    });
        }
        getMainWidth();
    }, [authInfo, isReset, navigate, login]);

    function requestReset() {
        const email = emailRef.current?.value;
        const pw = passwordRef.current?.value;

        if (!email || !pw) {
            toast.error(t('containers.validate.errors.required'));
            return;
        }

        try {
            const hash = nacl.hash(from(pw, "utf-8"));
            const hash2 = Buffer.from(hash).toString("base64");
            const hashedPw = bcrypt.hashSync(hash2, 10);
            signUp({ email, password: hashedPw, isReset: true, username: "resetOnly!" }).then(r => {
                if (!r?.err && !r?.error) {
                    toast.success(t('containers.validate.success'));
                } else {
                    if (r?.message?.includes("too many")) {
                        toast.error(t('containers.validate.errors.tooMany'), { autoClose: false });
                    } else {
                        toast.error(t('containers.validate.errors.unknown'), { autoClose: 30000 });
                    }
                }
            });
        } catch (e) {
            console.error("Password reset error:", e);
            toast.error(t('containers.validate.errors.unexpected'));
        }
    }


    return (
        <>
            <main className="main-content mt-1 border-radius-lg">

                <Breadcrumb text1={isReset ? t('containers.validate.resetTitle') : t('containers.validate.title')} text2={null}/>

                <div style={{display: "flex", justifyContent: "center", width: "100%", minHeight: "200px"}}>
                    <div className="my-2 text-light px-5 card-purple" style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        width: "66%",
                        minHeight: "100%"
                    }}>
                        {isReset ? <>
                                <br/>
                                <span className="text-center text-bolder">{t('containers.validate.emailLabel')}</span><br/>
                                <input ref={emailRef} className="input-purple text-center"/><br/>
                                <span className="text-center text-bolder">{t('containers.validate.passwordLabel')}</span><br/>
                                <input ref={passwordRef} type="password" className="input-purple text-center"/><br/>

                                <button className="btn btn-danger" onClick={() => requestReset()}>{t('containers.validate.requestButton')}</button>
                                <br/>
                                <span className="text-sm text-center text-warning">{t('containers.validate.limitNote')}</span><br/>
                            </> :
                            <Link className="text-light" to={"/"}>{t('containers.validate.signInLink')}</Link>}
                        {/*<InfoContainer text="Current Wallet:" title={ myData } />*/}
                    </div>
                </div>


            </main>
        </>
    );
}

export default ValidateContainer;
